import { ReactComponent as ChevronUp } from 'assets/icons/icon-chevron-up.svg';

export default ChevronUp;
